import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * Legacy redirect: this tab moved to the Explorer section (/explorer/catalog-images).
 * Kept so bookmarks and older deep links keep working instead of 404ing.
 */
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/integrations/catalog-images')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    // TanStack Router uses throw redirect() as control flow — not an error.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/explorer/catalog-images',
      // Forward every param the old URL carried, or the redirect would drop the
      // picked subsidiary on the way across.
      search,
    });
  },
});
